import React from "react";

function Icon({ className }) {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <circle cx="25" cy="25" r="24" fill="white" fillOpacity="0.5" />
        <circle cx="25" cy="25" r="24.5" stroke="white" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 19C15 16.7909 16.7909 15 19 15H31C33.2091 15 35 16.7909 35 19V31C35 33.2091 33.2091 35 31 35H19C16.7909 35 15 33.2091 15 31V19Z"
        stroke="#111111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.0001 24.37C29.2532 26.077 28.3831 27.7538 26.8417 28.5297C25.3003 29.3055 23.4351 29.0054 22.2149 27.7852C20.9947 26.5649 20.6946 24.6998 21.4704 23.1584C22.2462 21.617 23.9231 20.7469 25.6301 21C27.373 21.2585 28.7416 22.627 29.0001 24.37Z"
        stroke="#111111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_b"
          x="-10"
          y="-10"
          width="70"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImage" stdDeviation="5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default Icon;
